import styled from "styled-components";
import type { ReactNode, } from "react";
import { getTheme, themed, Flow, } from "@bracket/ui";


export declare type SwapCardContainerProps = {
  children: ReactNode;
};



/**
 * A container component for the swap card interface.
 * Provides a styled container with responsive design for both mobile and desktop views.
 * 
 * @component
 * @param {SwapCardContainerProps} props - The component props
 * @param {ReactNode} props.children - The child components to be rendered inside the container
 * @returns {JSX.Element} A styled container with the provided children
 */
export const SwapCardContainer = ({ children }: SwapCardContainerProps) => {
	themed();
  return <Container>{children}</Container>;
};


const Container = styled(Flow)`
  gap: 0.75rem;
  background: ${() => getTheme().surface_container_lowest};
  padding: 1rem;
  border-radius: 0;
  width: 100%;
  @media (min-width: 1024px) {
    gap: 1rem;
    border-radius: 0.5rem;
    padding: 1.5rem;
  }
`;
